<template>
    <div class="letter-paper">

        <div class="letter-content">
            <p>
                很高兴你愿意点开这封信。
            </p>
            <p>
                短短两次见面，竟已不能勾勒出你完整的模样。但你调皮地昂着头、坐在儿童游乐场笔直的背影、朝阳里的足球与操场、朋友圈里工整的板书与牛奶的合影、迎接2019新年的欢乐视频……这些画面时常突袭我的脑海，轻描一笔，又变得清晰如昨日。
            </p>
            <p>
                我曾是个回避的人，我回避了对你的好感，也回避了那段让你产生困扰的相亲经历。这让你退缩了，这份迟疑我理解，我也一直很自责。在最需要我解释的时候选择了沉默，让你一个人承担了所有的为难。我自负地以为沉默是尊重，后来我才明白，那是逃避。
            </p>
            <p>
                我也曾沉溺于幻想，幻想着你某一天会突然想通，然后一切不言自明。
            </p>
            <p>
                时至今日，我无法知道哪里来的勇气给你写这封信，也许这段文字会让你更加坚定对我原有的失望甚至反感。可是，当这冲动出现在我的脑海里时，我的老房子着了火，措手不及、无法扑灭，我决定做一次勇敢的人，我想冒着再次打扰你的风险表达这份迟到的感情。
            </p>
            <p>
                这份感情，如乱人心智的迷药，如久治不愈的顽疾。而我竟后知后觉，反应迟钝。它经历的时间也许短暂，却留下了长久的回忆；已然不再年少的年纪里，我在这段感情面前却稚嫩如孩童。
            </p>
            <p>
                这是一次不自量力的自白，是我这段心路的自白，是我对你、也是对自己的一次自白。你不需要答复，只是希望当你某一天愿意想到我，内心能够温暖地知道那个平静的夏天里有过怦然心动，之后的日子里也有过反复的回忆与念想。
            </p>
        </div>
    </div>
</template>

<style>
body,
html {
    margin: 0;
    background-color: #fdf6e3;
    font-family: Arial, sans-serif;
}

.letter-paper {
    padding: 32px;
    max-width: 800px;
    margin: 20px 10px;
    border: 1px solid #ccc;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    box-sizing: border-box;
}

.letter-header {
    font-family: "Palatino Linotype", "Book Antiqua", Palatino, Helvetica, STKaiti, SimSun, serif;
    margin-bottom: 40px;
    border-bottom: 2px LightGrey solid;
    width: 98%;
    line-height: 150%;
    color: #666666;
    display: block;
    font-size: 1.2em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
    text-align: left;
}

.letter-content {
    line-height: 1.8;
    font-family: "lucida grande", "lucida sans unicode", lucida, helvetica, "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", "PingFang SC","Helvetica Neue",STHeiti,Tahoma,Simsun,sans-serif;
    font-size: 18px;
    color: #333;
    text-align: left;
    /* 显式设置左对齐 */
}

@media (max-width: 600px) {
    .letter-paper {
        padding: 16px;
    }

    .letter-header {
        font-size: 1.1em;
    }

    .letter-content {
        font-size: 16px;
    }
}
</style>